var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VivatChartJS',{ref:"chart",staticClass:"scrollable-horizontal-bar-chart",attrs:{"type":"bar","data":_vm.data,"options":_vm.options,"height":_vm.height,"width":_vm.width},on:{"wheel":_vm.scroll}})}
var staticRenderFns = []

export { render, staticRenderFns }